import React from 'react';
import { Form, FormRenderProps } from 'react-final-form';

import { SegmentCreate as SegmentInput } from '@occc/graphql';
import { validate } from '@occc-app/routes/Segment/validation';

import { SegmentFormContent } from './SegmentFormContent';

export interface ISegmentFormProps {
  id?: string;
  initialValues: SegmentInput;
  onSubmit: (values: SegmentInput) => void;
  readOnly: boolean;
  editMode: boolean;
  disabled?: boolean;
}

export const SegmentForm: React.FC<ISegmentFormProps> = (props) => {
  const renderForm = React.useCallback(
    ({ handleSubmit }: FormRenderProps<SegmentInput>) => (
      <form id={props.id} onSubmit={handleSubmit}>
        <SegmentFormContent
          readOnly={props.readOnly}
          editMode={props.editMode}
          disabled={props.disabled}
        />
      </form>
    ),
    [props.id, props.readOnly, props.editMode, props.disabled],
  );

  return (
    <Form<SegmentInput>
      initialValues={props.initialValues}
      onSubmit={props.onSubmit}
      render={renderForm}
      validate={validate}
    />
  );
};
